import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { AnalyticsService } from 'src/app/shared/services/analytics.service';
import { ensureRenderFontsLoaded } from '../render-fonts';
import { RENDER_LANDING_URL } from '../render-home';
import { RENDER_LEGAL_DOCS, RenderLegalDoc } from './render-legal.data';

// The render service's four legal documents in the landing's paper and type, one page each
// (/legal/rendering-terms, …; routes in web-routing.module.ts, the document in the route's `doc`).
// The texts are in the template; render-legal.data.ts says where they came from.
@Component({
  selector: 'app-render-legal',
  templateUrl: './render-legal.component.html',
  styleUrls: ['./render-legal.component.scss'],
})
export class RenderLegalComponent implements OnInit, OnDestroy {
  public readonly docs = RENDER_LEGAL_DOCS;
  public readonly homeUrl = RENDER_LANDING_URL;
  public doc: RenderLegalDoc = RENDER_LEGAL_DOCS[0];

  private readonly previousTitle: string;
  private dataSub?: Subscription;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly title: Title,
    // "Cookie settings" in the footer: production only, with the banner it reopens.
    public readonly analytics: AnalyticsService,
    @Inject(DOCUMENT) private readonly document: Document,
  ) {
    this.previousTitle = this.title.getTitle();
  }

  public ngOnInit(): void {
    ensureRenderFontsLoaded(this.document);
    this.dataSub = this.route.data.subscribe((data) => {
      this.doc = RENDER_LEGAL_DOCS.find((doc) => doc.id === data.doc) ?? RENDER_LEGAL_DOCS[0];
      this.title.setTitle(`${this.doc.title} · 3DWay`);
    });
  }

  public ngOnDestroy(): void {
    this.dataSub?.unsubscribe();
    // The other pages set no title of their own: leave them the one they had.
    this.title.setTitle(this.previousTitle);
  }
}
